module.exports = __webpack_public_path__ + "img/inprogressAttach.eb5518e0.svg";